import React, { useContext, useState, useEffect } from 'react'
import { Container } from '../../base/Container';
import AppToaster from '../../commonLib/AppToaster';
import { ImageUploader } from '../../commonLib/ImageUploader';
import { LoadingButton } from '../../commonLib/LoadingButton';
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import { BASE_URL } from '../../initApi/apiUrls';
import * as applicationUserCrud from '../../_crud/applicationUserCrud';
import GetLoginInfo from '../../auth/_userContext/GetLoginInfo';
import SetLoginInfo from '../../auth/_userContext/SetLoginInfo';

export function UploadDP() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const userData = GetLoginInfo()
    const [photo, setPhoto] = useState("")

    const SetPhoto = (image) => {
        setPhoto(image)
    }
    const SavePhoto = () => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true);
        const formData = new FormData()

        formData.append('id', userData.id)
        formData.append('file', photo)
        applicationUserCrud.UploadDP(formData)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    AppToaster('Updated successfully.', 'success')
                    UpdateLocal(res.data.message)
                    window.location.reload()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }

            })
            .catch(error => {
                alert(error)
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    const UpdateLocal = (url) => {
        let data = userData;
        data = {...data, isDP:1, dpUrl:url}
        SetLoginInfo(data)
    }
    return (
        <Container title="Upload DP">

            <div className="row">
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                    <div class="form-group">
                        <div class="col-xs-12">
                            <label class="control-label no-padding-right"> Upload DP</label>
                            <ImageUploader initImage={userData.isDP == 1 ? BASE_URL + "/" + userData.dpUrl : undefined} SetImage={SetPhoto} />
                        </div>
                    </div>
                </div>
            </div>

            <div class="clearfix form-actions">
                <div class="pull-right">
                    {isLoadingLocal ?
                        <LoadingButton />
                        :
                        <button class="btn btn-info" type="submit" expand="block" onClick={SavePhoto} disabled={!photo}>
                            <i class="ace-icon fa fa-check bigger-110"></i>
                            Upload
                        </button>}
                </div>
            </div>

        </Container >
    )
}
